import { render, staticRenderFns } from "./projectIndex.vue?vue&type=template&id=13fe026a&scoped=true&"
import script from "./projectIndex.vue?vue&type=script&lang=js&"
export * from "./projectIndex.vue?vue&type=script&lang=js&"
import style0 from "./projectIndex.vue?vue&type=style&index=0&id=13fe026a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fe026a",
  null
  
)

export default component.exports